var _a;
import { proximal } from '@folkjs/geometry/Rect2D';
import { FolkHull } from './folk-hull';
import { FolkShape } from './folk-shape';
// TODO don't hard code this
const PROXIMITY = 125;
export class FolkCluster extends FolkHull {
    static { this.tagName = 'folk-cluster'; }
    static #config = new Map();
    static registerElement(config) {
        this.#config.set(config.constructor, config);
    }
    #data = new Map();
    isElementInCluster(element) {
        return this.sourceElements.has(element);
    }
    isElementInProximity(element) {
        for (const el of this.sourceElements) {
            if (proximal(el, element, PROXIMITY)) {
                return true;
            }
        }
        return false;
    }
    addElements(...elements) {
        const elementsSet = new Set(elements);
        const newElements = elementsSet.difference(this.sourceElements);
        this.sourceElements = this.sourceElements.union(elementsSet);
        let data = {};
        for (const geometry of newElements) {
            const element = geometry.firstElementChild;
            if (element === null)
                continue;
            const config = this.#getConfig(element);
            if (config) {
                for (const event of Object.keys(config.events || {})) {
                    element.addEventListener(event, this.#handleEvent);
                }
                const newData = config.onAdd?.(element);
                data = Object.assign(data, newData);
            }
        }
        this.#handleUpdate(data);
    }
    #handleEvent = (event) => {
        const config = this.#getConfig(event.currentTarget);
        if (config) {
            const data = config.events?.[event.type]?.(event);
            if (data === undefined)
                return;
            this.#handleUpdate(data);
        }
    };
    #handleUpdate(data) {
        const keys = new Set(Object.keys(data));
        for (const key of keys) {
            this.#data.set(key, data[key]);
        }
        for (const geometry of this.sourceElements) {
            const element = geometry.firstElementChild;
            if (element === null)
                continue;
            const config = this.#getConfig(element);
            config?.onUpdate?.(element, this.#data, keys);
        }
    }
    removeElement(geometry) {
        super.removeElement(geometry);
        const element = geometry.firstElementChild;
        if (element === null)
            return;
        const config = this.#getConfig(element);
        if (config) {
            for (const event of Object.keys(config.events || {})) {
                element.removeEventListener(event, this.#handleEvent);
            }
            config.onRemove?.(element);
        }
    }
    #getConfig(element) {
        const config = this.constructor.#config;
        return config.get(element.constructor);
    }
}
_a = FolkCluster;
export class FolkProximity extends HTMLElement {
    static { this.tagName = 'folk-proximity'; }
    static define() {
        if (customElements.get(this.tagName))
            return;
        FolkCluster.define();
        customElements.define(this.tagName, this);
        FolkShape.define();
    }
    #clusters = new Set();
    constructor() {
        super();
        this.addEventListener('transform', this.#handleProximity);
    }
    #handleProximity = (e) => {
        const el = e.target;
        const cluster = this.#findCluster(el);
        if (cluster === null) {
            for (const cluster of this.#clusters) {
                // what if its in proximity to multiple clusters?
                if (cluster.isElementInProximity(el)) {
                    cluster.addElements(el);
                    return;
                }
            }
            // The shape is not in a cluster so create a new one.
            const cluster = document.createElement('folk-cluster');
            cluster.addElements(el);
            this.#clusters.add(cluster);
            this.appendChild(cluster);
        }
        else {
            const isInCluster = Array.from(cluster.sourceElements)
                .filter((element) => el !== element)
                .some((element) => proximal(el, element, PROXIMITY));
            if (!isInCluster) {
                cluster.removeElement(el);
                if (cluster.sourcesMap.size === 1) {
                    this.#clusters.delete(cluster);
                    cluster.remove();
                }
            }
        }
    };
    #findCluster(element) {
        for (const cluster of this.#clusters) {
            if (cluster.isElementInCluster(element))
                return cluster;
        }
        return null;
    }
}
//# sourceMappingURL=folk-proximity.js.map